import { render, staticRenderFns } from "./PropostaParcelaEmail.vue?vue&type=template&id=65ae78f3"
import script from "./PropostaParcelaEmail.vue?vue&type=script&lang=js"
export * from "./PropostaParcelaEmail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports